import { useIntl } from '@doxyme/locale';
import { ModalHeader, ModalContent } from '@doxyme/ui/components/foundations';
import {
  InviteViaEmailForm,
  type InviteViaEmailFormProps,
} from '../inviteViaEmailForm';

import type { JSX } from 'react';

export type InviteByEmailPayload = {
  email: string[];
  language: string;
  message: string;
  edited: boolean;
  /*
   * Optional property to store calendar event data in iCalendar (.ics) format.
   *
   * The `calendarICS` field can be used to hold the serialized iCalendar data
   * for an event. This can be useful for exporting or sharing event information
   * with other calendar applications that support the iCalendar standard.
   *
   * Example usage:
   *   calendarICS: "BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\n..."
   */
  calendarICS?: string;
  date?: Date | null;
  time?: Date | null;
};

export type InviteViaEmailProModalContentProps = {
  onClose: () => void;
  form: InviteViaEmailFormProps;
  titleId?: string;
};

export const InviteViaEmailProModalContent = ({
  onClose,
  form,
  titleId,
}: InviteViaEmailProModalContentProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <ModalContent>
      <ModalHeader
        title={formatMessage({ id: 'inviteViaEmail' })}
        titleId={titleId}
        onClose={onClose}
      />

      <InviteViaEmailForm {...form} />
    </ModalContent>
  );
};
